(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-padelilli"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(pointer: fine)').matches;
  if (reduced || !finePointer) return;

  document.querySelectorAll('[data-pdl-hero]').forEach((hero) => {
    const front = hero.querySelector('[data-hero-front]');
    const back = hero.querySelector('[data-hero-back]');
    if (!front) return;

    let tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;

    const render = () => {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;

      front.style.setProperty('--tx', (cx * 18).toFixed(2) + 'px');
      front.style.setProperty('--ty', (cy * 10).toFixed(2) + 'px');
      front.style.setProperty('--rx', (-cy * 6 + 3).toFixed(2) + 'deg');
      front.style.setProperty('--ry', (-13 + cx * 10).toFixed(2) + 'deg');
      front.style.setProperty('--rz', (6 + cx * 2.2).toFixed(2) + 'deg');

      if (back) {
        back.style.setProperty('--tx', (-cx * 11).toFixed(2) + 'px');
        back.style.setProperty('--ty', (-cy * 7).toFixed(2) + 'px');
        back.style.setProperty('--rx', (-cy * 3 + 1).toFixed(2) + 'deg');
        back.style.setProperty('--ry', (10 + cx * 5).toFixed(2) + 'deg');
        back.style.setProperty('--rz', (-15 + cx * 1.5).toFixed(2) + 'deg');
      }

      if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) {
        raf = requestAnimationFrame(render);
      } else {
        raf = 0;
      }
    };

    const kick = () => {
      if (!raf) raf = requestAnimationFrame(render);
    };

    hero.addEventListener('pointermove', (event) => {
      if (window.innerWidth < 900) return;
      const rect = hero.getBoundingClientRect();
      tx = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - .5) * 2));
      ty = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - .5) * 2));
      kick();
    }, { passive: true });

    hero.addEventListener('pointerleave', () => {
      tx = 0;
      ty = 0;
      kick();
    }, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  document.querySelectorAll('[data-product-zoom]').forEach((holder) => {
    if (holder.dataset.bound) return;
    holder.dataset.bound = 'true';
    holder.addEventListener('click', () => {
      if (window.innerWidth < 900) return;
      holder.classList.toggle('is-zoomed');
    });
  });

  const key = 'pdl_recent_v1';
  document.querySelectorAll('[data-recent-product]').forEach((section) => {
    const item = {
      handle: section.dataset.handle || '',
      title: section.dataset.title || '',
      vendor: section.dataset.vendor || '',
      price: section.dataset.price || '',
      image: section.dataset.image || '',
      url: section.dataset.url || '',
      shape: section.dataset.shape || '',
      level: section.dataset.level || '',
      style: section.dataset.style || '',
      material: section.dataset.material || ''
    };
    if (!item.handle) return;
    let items = [];
    try { items = JSON.parse(localStorage.getItem(key) || '[]'); } catch (_error) {}
    items = items.filter((entry) => entry.handle !== item.handle);
    items.unshift(item);
    try { localStorage.setItem(key, JSON.stringify(items.slice(0,10))); } catch (_error) {}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdl-2027-launch"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-pdl27]');
  if (!root) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cards = root.querySelectorAll('[data-pdl27-card]');
  if ('IntersectionObserver' in window && !reduced) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .18 });
    cards.forEach((card) => observer.observe(card));
  } else {
    cards.forEach((card) => card.classList.add('is-visible'));
  }
  if (reduced || window.innerWidth < 900) return;
  cards.forEach((card) => {
    const visual = card.querySelector('.pdl27-visual');
    const racket = card.querySelector('.pdl27-racket');
    if (!visual || !racket) return;
    visual.addEventListener('pointermove', (event) => {
      const rect = visual.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - .5;
      const y = (event.clientY - rect.top) / rect.height - .5;
      racket.style.setProperty('--x', (x * 12).toFixed(1) + 'px');
      racket.style.setProperty('--y', (y * 8).toFixed(1) + 'px');
      racket.style.setProperty('--ry', (x * 10).toFixed(1) + 'deg');
      racket.style.setProperty('--rx', (-y * 7).toFixed(1) + 'deg');
      racket.style.setProperty('--rz', (x * 2).toFixed(1) + 'deg');
    });
    visual.addEventListener('pointerleave', () => {
      ['--x','--y','--ry','--rx','--rz'].forEach((name) => racket.style.removeProperty(name));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdl-cana"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-cana-program]').forEach((program) => {
    if (program.dataset.bound) return;
    program.dataset.bound = 'true';
    let started = false;
    const push = (event) => {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({event});
      document.dispatchEvent(new CustomEvent(event));
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) { push('cana_benefits_view'); observer.disconnect(); }
      },{threshold:.35});
      observer.observe(program);
    }
    program.querySelectorAll('[data-cana-input]').forEach((input) => {
      input.addEventListener('focus', () => {
        if (!started) { started = true; push('cana_registration_start'); }
      },{once:true});
    });
    const form = program.querySelector('form');
    form?.addEventListener('submit',(event) => {
      if (program.querySelector('[data-cana-honeypot]')?.value) event.preventDefault();
    });
    if (program.querySelector('[data-cana-success]')) {
      push('cana_registration_complete');
      try { localStorage.setItem('pdl_cana_registered','1'); } catch (_error) {}
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdl-padel-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const currency = window.Padelilli?.currency || 'MXN';
  const money = (value) => {
    let amount = Number(String(value || '0').replace(/[^0-9.]/g, ''));
    if (amount > 100000) amount = amount / 100;
    try { return new Intl.NumberFormat('es-MX',{style:'currency',currency,maximumFractionDigits:0}).format(amount); }
    catch (_error) { return '$' + Math.round(amount).toLocaleString('es-MX'); }
  };
  document.querySelectorAll('[data-pdl-finder]').forEach((finder) => {
    if (finder.dataset.bound) return;
    finder.dataset.bound = 'true';
    const intro = finder.querySelector('[data-finder-intro]');
    const progress = finder.querySelector('[data-finder-progress]');
    const progressText = finder.querySelector('[data-finder-progress-text]');
    const steps = [...finder.querySelectorAll('[data-finder-step]')];
    const answers = {};
    let index = 0;
    let started = false;

    const update = () => {
      steps.forEach((step, i) => step.classList.toggle('is-active', started && i === index));
      if (progress) progress.hidden = !started;
      if (progressText) progressText.hidden = !started;
      const bar = finder.querySelector('[data-finder-progress-bar]');
      if (bar) bar.style.width = ((index + 1) / steps.length * 100) + '%';
      if (progressText) progressText.textContent = 'PREGUNTA ' + (index + 1) + ' DE ' + steps.length;
    };

    const request = async (q) => {
      const url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
      const response = await fetch(url,{headers:{Accept:'application/json'}});
      if (!response.ok) return [];
      const json = await response.json();
      return json?.resources?.results?.products || [];
    };

    const fetchMatches = async () => {
      const results = finder.querySelector('[data-finder-results]');
      const holder = finder.querySelector('[data-finder-products]');
      const reason = finder.querySelector('[data-finder-reason]');
      const tokens = [answers.brand,answers.level,answers.style,answers.shape].filter(Boolean);
      if (reason) reason.textContent = 'Buscamos opciones según ' + (tokens.length ? tokens.join(' · ') : 'tus respuestas') + '. Sólo usamos datos disponibles del producto.';
      steps.forEach((step) => step.classList.remove('is-active'));
      if (progress) progress.hidden = true;
      if (progressText) progressText.hidden = true;
      if (results) results.hidden = false;
      if (holder) holder.innerHTML = '<p>Buscando opciones…</p>';
      let products = await request(tokens.join(' ') || 'palas');
      products = products.filter((product) => !/reno padel/i.test((product.vendor || '') + ' ' + (product.title || '')));
      if (answers.budget && Number(answers.budget) < 999999) {
        const max = Number(answers.budget);
        products = products.filter((product) => {
          let price = Number(String(product.price || 0).replace(/[^0-9.]/g,''));
          if (price > 100000) price = price / 100;
          return !price || price <= max;
        });
      }
      if (!products.length) products = await request([answers.brand,answers.style].filter(Boolean).join(' ') || 'palas');
      products = products.slice(0,5);
      if (!holder) return;
      holder.innerHTML = products.length ? products.map((product) => {
        const image = product.image || product.featured_image?.url || product.featured_image || '';
        return '<article class="pdl-finder-product">' +
          (image ? '<img src="' + image + '" alt="">' : '') +
          '<small>' + (product.vendor || '') + '</small><strong>' + product.title + '</strong><span>' + money(product.price) + '</span><a href="' + product.url + '">VER PALA</a></article>';
      }).join('') : '<p>No encontramos una coincidencia clara. Prueba cambiando una preferencia.</p>';
    };

    finder.querySelector('[data-finder-start]')?.addEventListener('click', () => {
      started = true; index = 0; if (intro) intro.hidden = true; update();
    });
    steps.forEach((step) => {
      step.querySelectorAll('[data-finder-answer]').forEach((button) => {
        button.addEventListener('click', () => {
          answers[step.dataset.key] = button.dataset.finderAnswer || '';
          step.querySelectorAll('[data-finder-answer]').forEach((item) => item.classList.remove('is-selected'));
          button.classList.add('is-selected');
          window.setTimeout(() => {
            if (index < steps.length - 1) { index += 1; update(); } else { fetchMatches(); }
          },140);
        });
      });
    });
    finder.querySelector('[data-finder-restart]')?.addEventListener('click', () => {
      Object.keys(answers).forEach((key) => delete answers[key]);
      index = 0; started = false;
      finder.querySelector('[data-finder-results]').hidden = true;
      steps.forEach((step) => step.querySelectorAll('.is-selected').forEach((item) => item.classList.remove('is-selected')));
      if (intro) intro.hidden = false; update();
    });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdl-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = 'pdl_recent_v1';
  document.querySelectorAll('[data-recently-viewed]').forEach((section) => {
    const holder = section.querySelector('[data-recent-grid]');
    if (!holder) return;
    let items = [];
    try { items = JSON.parse(localStorage.getItem(key) || '[]'); } catch (_error) {}
    if (!items.length) return;
    section.classList.add('has-items');
    holder.innerHTML = items.slice(0,5).map((item) => '<a class="pdl-recent-card" href="' + item.url + '">' +
      (item.image ? '<img src="' + item.image + '" alt="">' : '') +
      '<small>' + (item.vendor || '') + '</small>' +
      '<strong>' + item.title + '</strong>' +
      '<span>' + (item.price || '') + '</span>' +
    '</a>').join('');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
